// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZDLBVly968wGo6GRonTs.YoanjlCyM7sRvnX9Zm8g{font-size:20px}.ZDLBVly968wGo6GRonTs.e9yD2hfDrXEeszETrIA7,.ZDLBVly968wGo6GRonTs.qqGGFLeBoSUyIoPJJ5Rs{font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categorySize": "ZDLBVly968wGo6GRonTs",
	"full": "YoanjlCyM7sRvnX9Zm8g",
	"compact": "e9yD2hfDrXEeszETrIA7",
	"medium": "qqGGFLeBoSUyIoPJJ5Rs"
};
module.exports = ___CSS_LOADER_EXPORT___;
